export class User {
  id: string;
  username: string;
  heslo: string;
  nazev: string;
  role: string;
  email: string;
  poznamka: string;
  active: boolean;
  authdata?: string;
  date: Date;
  owner: string | null

}
